import { Link } from "react-router-dom";
import {
  CAlert,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CSpinner,
} from "@coreui/react-pro";
import { useCustomerProfile } from "../../api/hooks/useCustomerProfile";
import { routePaths } from "../../routes/route-paths";
import { PlatformAccountsCard } from "./PlatformAccountsCard";

export function ProfileLandingCoreui() {
  const profile = useCustomerProfile();

  return (
    <div>
      <h2>Profile</h2>
      <p className="text-body-secondary">
        Manage your account details and how you sign in.
      </p>

      {profile.isLoading && <CSpinner />}
      {profile.isError && (
        <CAlert color="warning">
          We couldn't load your profile right now. Please try again in a
          moment.
        </CAlert>
      )}

      <CRow xs={{ gutter: 4 }}>
        <CCol md={6}>
          <CCard className="h-100">
            <CCardHeader>Identity</CCardHeader>
            <CCardBody className="d-flex flex-column">
              <dl className="mb-3">
                <dt>First name</dt>
                <dd>{profile.data?.firstName || "—"}</dd>
                <dt>Last name</dt>
                <dd>{profile.data?.lastName || "—"}</dd>
              </dl>
              <Link
                to={routePaths.profileEdit}
                className="btn btn-primary mt-auto align-self-start"
              >
                Edit profile
              </Link>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6}>
          <CCard className="h-100">
            <CCardHeader>Sign-in</CCardHeader>
            <CCardBody className="d-flex flex-column">
              <dl className="mb-3">
                <dt>Email</dt>
                <dd>{profile.data?.email || "—"}</dd>
                <dt>Password</dt>
                <dd>
                  <span aria-hidden="true">••••••••••</span>
                  <span className="visually-hidden">Hidden</span>
                </dd>
              </dl>
              <p className="text-body-secondary small">
                Changing your email needs a code sent to the new address.
                Changing your password needs your current one.
              </p>
              <div className="d-flex flex-wrap gap-2 mt-auto">
                <Link to={routePaths.profileEmail} className="btn btn-outline-primary">
                  Change email
                </Link>
                <Link to={routePaths.profilePassword} className="btn btn-outline-primary">
                  Change password
                </Link>
              </div>
            </CCardBody>
          </CCard>
        </CCol>

        <PlatformAccountsCard />

        <CCol md={6}>
          <CCard className="h-100">
            <CCardHeader>Billing</CCardHeader>
            <CCardBody className="d-flex flex-column">
              <p className="text-body-secondary mb-3">
                Your card, invoices and receipts cover your whole account — one
                payment method and one monthly invoice across your
                subscriptions.
              </p>
              <Link
                to={routePaths.billing}
                className="btn btn-outline-primary mt-auto align-self-start"
              >
                Go to billing
              </Link>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6}>
          <CCard className="h-100">
            <CCardHeader>Communication preferences</CCardHeader>
            <CCardBody className="d-flex flex-column">
              <p className="text-body-secondary mb-3">
                Choose which emails you get from us — signals from your strategies, new
                strategies, updates on the requests you have made, and offers.
              </p>
              <Link
                to={routePaths.profileCommunications}
                className="btn btn-outline-primary mt-auto align-self-start"
              >
                Manage preferences
              </Link>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}
